export enum ContractType {
  ARTICLE_45 = 'ARTICLE_45',
  MANAGEMENT_AGREEMENT = 'MANAGEMENT_AGREEMENT',
}

/** Same wording as the matching `DocumentType` entries. */
export const getContractTypeLabel = (value: ContractType | string): string => {
  switch (value) {
    case ContractType.ARTICLE_45:
      return $localize`Article 45`;
    case ContractType.MANAGEMENT_AGREEMENT:
      return $localize`Mandat de gestion`;
    default:
      return value;
  }
};
